import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import Icon from 'Pods/Shared/Icon/Icon'

import BadStructureDiagram from 'images/upload/bad_structure.png'

function BadStructureModal(props) {
  return (
    <Modal
      isOpen={props.modalIsOpen}
      onRequestClose={props.closeModal}
      contentLabel="Modal"
      ariaHideApp={false}
      className={{
        base: '',
        afterOpen: 'overlay-modal--container_after-open is-full-size',
        beforeClose: 'overlay-modal--container_before-close',
      }}
      overlayClassName={{
        base: 'overlay-modal--background',
        afterOpen: 'overlay-modal--background_after-open',
        beforeClose: 'overlay-modal--background_before-close',
      }}
    >
      <div className="overlay-modal overlay-modal--batch-upload-bad-structure">
        <div className="overlay-modal--content">
          <div className="l-inner-large">
            <h2 className="content-heading__h2 text-semibold">Attention!</h2>

            <p className="text-dark">
              We have noticed that you are attempting to upload files in a different structure than we require. This might result in a failed upload.
            </p>
            <p className="text-dark">
              Please <span className="text-warning">revise your folder structure</span> so your upload looks as follows:
            </p>

            <div className="content__image-container">
              <img src={BadStructureDiagram} alt="Bad structure diagram" />
            </div>

            <div className="u-text-right">
              <button className="btn btn-outline-default btn-fat u-mt10 u-mr10" onClick={props.closeModal}>
                Take me back
              </button>
              <button className="btn btn-primary btn-fat u-mt10" onClick={() => zE('webWidget', 'toggle')}>
                Contact support
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

BadStructureModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
}

export default BadStructureModal
